const iconsName: string[] = [
  '餐饮',
  '交通',
  '购物',
  '服饰',
  '娱乐',
  '红包',
  '水电',
  '烟酒',
  '水果',
  '日用品',
  '美容',
  '住房',
  '通讯',
  '蔬菜',
  '学习',
  '旅游',
  '运动',
  '孩子',
  '宠物',
  '居家',
  '书籍',
  '维修',
  '医疗',
  '数码',
  '捐赠',
  '礼金',
  '礼物',
  '办公',
  '社交',
  '长辈',
  '彩票',
  '零食',
  '快递',
  '工资',
  '兼职',
  '理财',
  '报销',
  '奖金',
  '其他',
];

export default iconsName;
